import { PaymentMethod } from '@stripe/stripe-js'
import { EUROPE_ECONOMIC_AREA, STRIPE_PAYMENT_FEES } from './processor-fees'

export const getBankingCountryByPaymentMethod = (
  paymentMethod: PaymentMethod
) => {
  if (!paymentMethod) return undefined
  const { type, card } = paymentMethod
  return card?.country ?? undefined
}

export const getProcessorFees = (regionCode?: string) => {
  if (!regionCode) return STRIPE_PAYMENT_FEES.INTERNATIONAL
  if (regionCode === 'GB') return STRIPE_PAYMENT_FEES.GBP
  if (EUROPE_ECONOMIC_AREA.includes(regionCode)) return STRIPE_PAYMENT_FEES.EEA
  return STRIPE_PAYMENT_FEES.INTERNATIONAL
}

export const getDonationTotal = ({
  amount,
  platformFee,
  regionCode,
  coverPlatformFee,
}: {
  amount: number
  platformFee: number
  regionCode?: string
  coverPlatformFee?: boolean
}) => {
  let donationAmountCents = amount

  let totalDonationCents = 0

  const platformFeeAmountCents = donationAmountCents * (platformFee / 100)

  totalDonationCents = donationAmountCents

  if (coverPlatformFee) {
    totalDonationCents = donationAmountCents + platformFeeAmountCents
  }

  donationAmountCents = totalDonationCents - platformFeeAmountCents

  return {
    donation: donationAmountCents, // Amount going to charity (in cents)
    platformFee: platformFeeAmountCents, // Platform fee (in cents)
    total: totalDonationCents, // Total donation amount (in cents)
    regionCode,
  }
}
